<div class="modal-header">
  {{this.project.name}}&nbsp;
  <span i18n="@@delete-small">löschen</span>
</div>

<div class="modal-body">
  <div class="card-body">
    <p i18n="@@delete-project-description">
      Beim Löschen dieses Projekts werden alle enthaltenen Bots standardmäßig in „Meine Bots“ der Besitzer verschoben.
      Alternativ kannst du wählen, dass alle Bots in den Papierkorb verschoben werden.
    </p>
    <div style="display: flex; align-items: center; gap: 0.5rem;">
      <p-checkbox
        [style]="{'margin-bottom': '3px'}"
        inputId="trashbots"
        [binary]="true"
        [(ngModel)]="this.trashbots"
        size="small"
      ></p-checkbox>
      <label
        for="trashbots"
        i18n="@@delete-project-trashbots"
      >Bots stattdessen in den Papierkorb verschieben</label>
    </div>
  </div>
</div>

<div class="modal-footer">
  <p-button
    type="button"
    severity="danger"
    label="Projekt löschen"
    i18n-label="@@delete"
    label="Projekt löschen"
    i18n-label="@@delete-project-button"
    (onClick)="this.deleteProject()"
  ></p-button>
</div>